/* jshint node:true */

module.exports = {
    Router: require('./Router'),
    UriTemplate: require('./UriTemplate')
};


//////////////////
// WEBPACK FOOTER
// ./~/rfc6570/src/main.js
// module id = 15
// module chunks = 0